<template>
  <component :is="layout">
    <router-view />
  </component>
  <div class="modal modal-condition" tabindex="-1" :class="showModal ? 'show' : ''">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">CHARTE DE PROTECTION DES DONNÉES PERSONNELLES ET COOKIES</h4>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="showModal = false"
          />
        </div>
        <div class="modal-body">
          <p> Bienvenue sur la plateforme web [URL_Base]. 
            En vous connectant ou en consultant le site internet, 
            vous reconnaissez avoir lu, compris, et accepté, sans limitation ni réserve, 
            la présente Charte de protection des données personnelles et cookies (ci-après la « Charte ») 
            et nos conditions générales d’utilisation.     
          </p>
          <p>La Charte vise à vous informer des droits 
            et libertés que vous pouvez faire valoir à l'égard 
            de notre utilisation de vos données personnelles et 
            décrit les mesures que nous mettons en œuvre afin de les protéger.
          </p>
          <p>La plateforme Écoles, 
            est la propriété de la société Elyos Digital, 
            dont le siège social est situé à Rue Mohamed Shim – Rbat 5000 Monastir. 
            Nommé le « responsable du traitement » des données personnelles relatives 
            à la gestion du site internet. Ces traitements sont mis en œuvre conformément au droit applicable.
          </p>
          <h5 class="second-title">1. Finalité, fondement du traitement des données collectées et durée de conservation</h5>
          <p>Avez de pouvoir accéder à la Plateforme 
            Ecoles et utiliser les services proposés dans 
            le cadre de gestion de votre école, 
            vous nous fournissez un certain nombre de données personnelles 
            relatives à vous, vos collaborateurs ou votre établissement y compris ses élèves.
          </p>
          <p>
            <strong>Le traitement de vos données personnelles se fonde sur votre 
              consentement exprimé dans votre demande d’accès à la plateforme auprès des administrateurs.
            </strong>Ces informations sont nécessaires pour vous donner accès aux contenus de la plateforme 
            et ainsi bénéficier des services.
          </p>
          <p>Le traitement de vos données personnelles se fonde 
            sur votre consentement exprimé dans votre demande 
            d’accès à la plateforme auprès des administrateurs.
          </p>
          <h5 class="second-title">2. Destinataires des données</h5>
          <p>Afin de satisfaire les finalités précisées ci-dessus, 
            vos données personnelles sont transmises à la société tunisienne Elyos Digital, développeur de l'Application :
          </p>
          <ul>
            <li> - Les services de développement et de maintenance de 
              l'Application aux sociétés tunisiennes, 
              ELYOS DIGITAL et ELYOS DIGITAL TUNISIE.
            </li>
            <li>- L’hébergement de vos données personnelles à 
              la société française E2LYS (serveurs localisés en France).
            </li>
          </ul>
          <h5 class="second-title">3. Transferts de données</h5>
          <p>Tout transfert de données vers un pays tiers hors de 
            l’Espace Économique tunisien est réalisé en conformité 
            avec la règlementation applicable et de manière à assurer une protection adéquate des données.
          </p>
          <p>Au titre des services fournis sur le site, les données relatives à vous,
            vos collaborateurs ou votre établissement y compris ses élèves peuvent être transférées
            à des entités d’Elyos Digital établies hors de l’Espace Économique tunisien. Pour cela, 
            le Elyos Digital a adopté des Règles d’Entreprise Contraignantes (BCR) applicables à l’ensemble des entités 
            permettant d’encadrer les transferts intra de vos données personnelles en dehors de la Tunisie
          </p>
          <p>Pour toute information sur les mesures mises en place pour assurer 
            une protection adéquate, veuillez écrire à l’adresse de contact mentionnée ci-après.
          </p>
          <h5 class="second-title">4. Sécurité et confidentialité de vos données</h5>
          <p>Le responsable du traitement met en œuvre des mesures appropriées pour préserver 
            la sécurité et la confidentialité de vos données personnelles et, notamment, 
            pour empêcher qu’elles soient déformées, endommagées, ou que des tiers non autorisés y aient accès.
          </p>
          <h5 class="second-title">5. Gestion des cookies</h5>
          <p>Un cookie est un fichier qui permet d’enregistrer des informations 
            relatives à votre navigation et de la faciliter sur [URL_de_Base].
          </p>
          <p>Les cookies sont des fichiers texte qui sont déposés sur votre terminal. 
            Ils permettent d’accéder à différentes informations vous concernant. 
            Certains d’entre eux appartiennent à l’éditeur du site, 
            d’autres à des opérateurs tiers. Le tableau ci-dessous donne une vue détaillée sur chaque cookie/traceur.
          </p>
          <p>Nous n’utilisons que des cookies techniques non paramétrables nécessaires au bon fonctionnement 
            de la Plateforme Écoles et au respect de la législation en vigueur.
          </p>
          <strong>Quels sont les cookies installés ?</strong>
          <p class="title">• Les cookies proposés par HUTCHINSON sur la plateforme Écoles</p>
          <table data-v-fe80ad90="" class="table b-table table-sm resizable-tab" style="margin-bottom:17px">
            <thead data-v-fe80ad90="">
              <tr data-v-fe80ad90="" class="charter-header-tab" style="border-top-width: 1px;">
                <th data-v-fe80ad90="">
                  <p data-v-fe80ad90="" class="mb-0">Editeur du Cookie</p></th> 
                <th data-v-fe80ad90=""><p data-v-fe80ad90="" class="mb-0">Description</p></th> 
                <th data-v-fe80ad90=""><p data-v-fe80ad90="" class="mb-0">Comment refuser ?</p></th> 
                <th data-v-fe80ad90=""><p data-v-fe80ad90="" class="mb-0">Durée</p>
                </th>
              </tr>
            </thead> 
            <tbody data-v-fe80ad90="">
              <tr data-v-fe80ad90="" class="charter-body-tab">
                <td data-v-fe80ad90="">
                  <p data-v-fe80ad90=""><strong data-v-fe80ad90="">Cookies techniques </strong></p> 
                  <p data-v-fe80ad90="">(XSRF-TOKEN)</p>
                </td> 
                <td data-v-fe80ad90="">
                  <p data-v-fe80ad90="">Assure la sécurité de votre navigation sur la Plateforme Écoles en empêchant la falsification des requêtes entre sites. </p>
                </td> 
                <td data-v-fe80ad90="">
                  <p data-v-fe80ad90="">Impossible, ils sont indispensables pour assurer votre sécurité ainsi que celle de la plateforme Écoles.</p></td>
                <td data-v-fe80ad90="">
                  <p data-v-fe80ad90=""> 1 jour </p>
                </td>
              </tr> 
              <tr data-v-fe80ad90="" class="charter-body-tab">
                <td data-v-fe80ad90="">
                  <p data-v-fe80ad90="">
                    <strong data-v-fe80ad90="">Cookies techniques </strong>
                  </p> 
                  <p data-v-fe80ad90=""> (WorkÉcoles session) </p>
                </td> 
                <td data-v-fe80ad90="">
                  <p data-v-fe80ad90="">Contient des informations sur la session de navigation, permet à l’utilisateur d’accéder à la Plateforme Écoles. </p>
                </td> 
                <td data-v-fe80ad90="">
                  <p data-v-fe80ad90="">Impossible, ils sont indispensables au fonctionnement de notre plateforme. </p>
                </td> 
                <td data-v-fe80ad90="">
                  <p data-v-fe80ad90=""> 1 jour </p>
                </td>
              </tr>
              <tr data-v-fe80ad90="" class="charter-body-tab">
                <td data-v-fe80ad90="">
                  <p data-v-fe80ad90="">
                    <strong data-v-fe80ad90="">Cookies techniques </strong>
                  </p> 
                  <p data-v-fe80ad90=""> (lang) </p>
                </td> 
                <td data-v-fe80ad90="">
                  <p data-v-fe80ad90="">Cookie utilisé pour vous permettre de choisir la langue de lecture de notre Plateforme Écoles </p>
                </td> 
                <td data-v-fe80ad90="">
                  <p data-v-fe80ad90="">Impossible, ils sont indispensables à votre lecture et votre bonne compréhension de notre plateforme Écoles. </p>
                </td> 
                <td data-v-fe80ad90="">
                  <p data-v-fe80ad90=""> Persistent</p>
                </td>
              </tr>
            </tbody>
          </table>
          <h5 class="second-title">6. Vos droits / Contact</h5>
          <p>Conformément à la règlementation en vigueur, 
            vous disposez d’un droit d’accès, de rectification,
            de suppression et d’opposition de vos données personnelles. 
            Vous disposez également d’un droit d’opposition à la prospection commerciale dans 
            les conditions de la réglementation applicable. Vous pouvez demander 
            la communication de vos données personnelles et vous avez le droit de définir 
            des directives relatives au sort de vos données personnelles après votre décès. 
            Vous pouvez également demander la limitation du traitement ou la portabilité de vos données personnelles.
          </p>
          <p>Vous pouvez exercer vos droits et nous interroger sur le traitement de vos données personnelles en écrivant à notre relais 
            <strong>rpdg@ecoles.com.tn.</strong>
          </p>
          <p>Enfin, vous pouvez introduire une réclamation auprès de l’autorité en charge du respect 
            des obligations en matière de protection des données personnelles 
            (Instance nationale de protection des données à caractère personnel - INPDP - pour la Tunisie).
          </p>
          <h5 class="second-title">7. Liens externes</h5>
          <p>Si notre Plateforme Écoles vous donne accès à des sites internet, 
            lesdits sites internet ne sont pas soumis à la présente Charte. 
            Nous vous conseillons de consulter les Chartes de protection des données 
            personnelles/ déclarations de confidentialité de ces sites internet pour connaître leurs pratiques 
            en matière de collecte, d'utilisation et de divulgation des données personnelles.
          </p>
          <h5 class="second-title">8. Modification de la Charte</h5>
          <p>La présente Charte a été mise à jour le 19 Juillet 2022. 
            La dernière version est disponible dans la rubrique Données Personnelles de notre site web.
            Nous nous réservons le droit de réviser et de modifier la présente Charte à tout moment, 
            notamment pour nous conformer aux exigences règlementaires et légales.
          </p>
        </div>
      </div>
    </div>
  </div>
  <vue-cookie-accept-decline
    :debug="false"
    :disableDecline="false"
    :showPostponeButton="false"
    @clicked-accept="cookieClickedAccept"
    @clicked-decline="cookieClickedDecline"
    @clicked-postpone="cookieClickedPostpone"
    @removed-cookie="cookieRemovedCookie"
    @status="cookieStatus"
    elementId="myPanel1"
    position="bottom-left"
    ref="myPanel1"
    transitionName="slideFromBottom"
    type="floating"
  >
    <!-- Optional -->
    <template #postponeContent>&times;</template>

    <!-- Optional -->
    <template #message>
      Nous n’utilisons que des cookies techniques non paramétrables
      nécessaires au bon fonctionnement de notre plateforme et au respect
      de la législation en vigueur. Pour plus d’informations, vous pouvez
      consulter la page
      <span
        class="pointer_text"
        @click="showModalCOndition()"
      >« Charte de données personnelles ».</span>
    </template>

    <!-- Optional -->
    <template #acceptContent>OK</template>
  </vue-cookie-accept-decline>
</template>

<script>
export default {
  data() {
    return {
      status: null,
      showModal: false
    };
  },
  methods: {
    cookieStatus(status) {
    
      this.status = status;
    },
    cookieClickedAccept() {
      this.status = "accept";
    },
    cookieClickedDecline() {
      this.status = "decline";
    },
    cookieClickedPostpone() {
      this.status = "postpone";
    },
    cookieRemovedCookie() {
      this.status = null;
      this.$refs.myPanel1.init();
    },
    removeCookie() {
      this.$refs.myPanel1.removeCookie();
    },
    showModalCOndition() {
      this.showModal = true;
    }
  },
  computed: {
    layout() {
      return `layout-${this.$route.meta.layout || "default"}`;
    },
    statusText() {
      return this.status || "No cookie set";
    }
  }
};
</script>
